import reduce from 'lodash/reduce';

export type ReplaceMap = {
  [key: string]: string | number;
};

export function getCompletedLocaleText(locale: string, replaceMap: ReplaceMap): string {
  return reduce(
    replaceMap,
    (text, replaceValue, replaceKey) => text.replace(new RegExp(`{${replaceKey}}`, 'g'), replaceValue.toString()),
    locale
  );
}
